import { create } from 'zustand';

const THEMES = {
  DEFAULT: 'default',
  ALTMAN_SOLON: 'altman-solon',
};

const useThemeStore = create((set, get) => ({
  THEMES,
  theme: THEMES.DEFAULT,
  setTheme: (theme) => set({ theme }),
}));

export default useThemeStore;
